export default __webpack_public_path__ + "static/media/arrow-up.ef88ac04.svg";